import * as React from "react";

import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";

import { redirectRequest } from "../common/msal";

type PropsType = React.PropsWithChildren & {};

export default function RequireAuthentication(props: PropsType) {
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      errorComponent={RequireAuthenticationError}
      loadingComponent={RequireAuthenticationLoading}
      authenticationRequest={redirectRequest}>
      {props.children}
    </MsalAuthenticationTemplate>
  );
}

function RequireAuthenticationError() {
  return (
    <div className="container">
      <div className="row mt-5">
        <div className="col text-center">
          <h4>Authentication Error</h4>
          <p>
            There has been an error signing you into this workspace. Please
            contact support.
          </p>
        </div>
      </div>
    </div>
  );
}

export function RequireAuthenticationLoading() {
  const WIB_PORTAL_URL = process.env.WIB_PORTAL_URL;

  return (
    <div className="container">
      <div className="row mt-5">
        <div className="col text-center">
          <h4>Logging in ...</h4>
          <p>
            You may also navigate back to the user{" "}
            <a href={WIB_PORTAL_URL}>portal</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
